module.exports = __webpack_public_path__ + "img/logoEn1.f5e81560.svg";